<template>
<v-dialog ref="dialog" v-model="showPicker"
  :return-value.sync="date" persistent lazy full-width width="290px" >
  <v-text-field slot="activator" v-model="date"
    :label="label" prepend-icon="event" readonly >
  </v-text-field>
  <v-date-picker v-model="date" >
    <v-spacer></v-spacer>
    <v-btn flat color="primary" @click="showPicker = false">Cancel</v-btn>
    <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
  </v-date-picker>
</v-dialog>
</template>

<script>
export default {
  name: 'DatePickerDialog',
  props: {
    value: { type: String },
    label: { type: String, default: 'Choose a date' },
    closeOnChange: { type: Boolean, default: false }
  },
  data () {
    return {
      showPicker: false,
      date: null
    }
  },
  mounted () {
    if (this.value) { this.date = this.value }
  },
  watch: {
    value () {
      if (this.value) { this.date = this.value }
    },
    date () {
      this.$emit('input', this.date)
      if (this.closeOnChange) { this.$refs.dialog.save(this.date) }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// DatePickerDialog.vue?602df8e0